module.exports = __webpack_public_path__ + "static/media/FBI Visualization.48eba723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/PortfolioImages/FBI Visualization.jpg
// module id = 98
// module chunks = 0